import { useEffect } from 'react';

interface UsePaymentSuccessMessageProps {
  onPaymentSuccess: () => void;
}

export const usePaymentSuccessMessage = ({ onPaymentSuccess }: UsePaymentSuccessMessageProps) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      const message = event.data as { type?: string } | undefined;
      if (message?.type !== 'PAYMENT_SUCCESS') return;

      onPaymentSuccess();
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onPaymentSuccess]);
};
